export default __webpack_public_path__ + "static/media/k17.8f133085.jpg";